import { useBoundStore } from 'useStore';
import FreeShippingIndicator from './FreeShippingIndicator';
import { useShallow } from 'zustand/react/shallow';

export default function ProjectedFreeShipping({ value, id, field, params }) {
	const editedValue = useBoundStore(
		useShallow((state) => state.pricingEditedRows[id]?.[field])
	);

	let currentValue = editedValue ?? value;

	if (params?.row?.site === 'AMZN') {
		currentValue = params?.row?.freeshipping;
	}

	return <FreeShippingIndicator value={currentValue} />;
}
